import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { GroupCondition, ConditionEditorProperty } from "@/lib/helpers/condition";
import ConditionGroup from "./group.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'editor',
  props: {
    modelValue: {},
    properties: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ConditionGroup, {
    properties: __props.properties,
    "model-value": __props.modelValue,
    "max-depth": 2,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (x) => emit('update:modelValue', x))
  }, null, 8, ["properties", "model-value"]))
}
}

})